var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49951 10.5L11.4995 13.5L15.9995 9M3.99951 6.5V7.5C3.99951 12.5361 6.37062 17.2783 10.3995 20.3L11.9995 21.5L13.7264 20.281C17.9737 17.2829 20.4995 12.4083 20.4995 7.2095V6.5L18.867 6.17349C16.6473 5.72955 14.547 4.81966 12.705 3.50394L11.9995 3L11.1495 3.60718C9.40075 4.85626 7.41835 5.74026 5.32053 6.20644L3.99951 6.5Z",
    stroke: "currentColor",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.b619b34d1479438a96e0bb345dd7431b.svg";
export { ForwardRef as ReactComponent };